/* eslint-disable import/no-cycle */
import axios from 'axios';
// import { NormalGet, NormalPost, NormalDelete } from '@/js/request';
import request, { NormalGet, NormalDelete, NormalPost, NormalPut } from '@/js/request';

const modelName = process.env.VUE_APP_APIPrefix_system || '';
export const SystemLangGet = (data) => {
  return NormalGet(modelName, '/lang', data);
};

export const SystemHealthCheckGet = (data) => {
  return NormalGet(modelName, '/health_check', data);
};

/** 系統登入 */
export const SystemAuthLoginPost = (loginData, type, name) => {
  return axios
    .create({
      baseURL: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: `Basic ${loginData}`,
        // Authorization: loginData,
      },
      withCredentials: true,
    })
    .post(`${modelName}/authLogin?login_type=${type}&login_name=${name}`);
};

// export const SystemAuthLoginPost = (data) => { return NormalPost(modelName, '/authlogin', data); };
/** 驗證 token 是否有被 insert */
export const SystemAuthInsertTokenGet = (data) => {
  return NormalGet(modelName, '/token', data);
};

export const SystemAuthRefreshToken = (data) => {
  return NormalPost(modelName, '/token', data);
};
export const SystemAuthRemoveTokenDel = (data) => {
  return NormalDelete(modelName, '/token', data);
};

/** 撈取頁面權限 */
export const SystemPermissionGetMenuItemGet = (data) => {
  return NormalGet(modelName, '/getMenuItem', data);
};

/** 透過撈取頁面權限取得選單 */
export const GetMenu = async () => {
  return SystemPermissionGetMenuItemGet();
};

/** 取得廠區授權 */
export const GetBusinessLicense = (data) => {
  return NormalPost(modelName, '/getDefault/menuItem', data);
};

/** 取得切換的 BU List */
export const SystemPermissionGetBUList = (data) => {
  return NormalGet(modelName, '/buSwitch', data);
};

/** 切換 BU 時確認資料庫連線 */
export const SwitchBUCheckDB = (data) => {
  return NormalPost(modelName, '/buSwitch', data);
};

/** 取得層別設定的 CURD 動態欄位 */
export const SystemLevelCURDGet = (data) => {
  return NormalGet(modelName, '/level/setting/menu', data);
};

/** 取得層別設定的表格內容 & 搜尋 */
export const SystemLevelTableGet = (data) => {
  return NormalGet(modelName, '/level/setting', data);
};

/** 取得層別設定下拉選單、在上方搜尋時要卡控、Create & Edit時不用 */
export const SystemLevelDropDownMenu = (data) => {
  return NormalPost(modelName, '/level/setting/menu', data);
};

/** 增加層別設定 */
export const SystemLevelCreate = (data) => {
  return NormalPost(modelName, '/level/setting', data);
};

/** 修改已有層別設定 */
export const SystemLevelUpdate = (data) => {
  return NormalPut(modelName, '/level/setting', data);
};

/** 刪除已有層別設定 */
export const SystemLevelDelete = (data) => {
  return NormalDelete(modelName, '/level/setting', data);
};

/** 廠區清單 */
export const SystemBuGetList = (data) => {
  return NormalGet(modelName, '/bu', data);
};

/** 新增廠區 */
export const SystemBuCreate = (data) => {
  return NormalPost(modelName, '/bu', data);
};

/** 修改廠區資料 */
export const SystemBuUpdate = (data) => {
  return NormalPut(modelName, '/bu', data);
};

/** 刪除已有廠區 ?bu_key=78431795-3F8C-45BB-965A-BAA133FC9D78 */
export const SystemBuDelete = (data) => {
  return NormalDelete(modelName, `/bu${data}`, '');
};

export const SystemBuDBTest = (data) => {
  return NormalPost(modelName, '/bu/connectTest', data);
}; // 廠區新增 or 修改 DB Test

/** 分析等級設定 */
export const SystemAnalizeRankGet = (data) => {
  return NormalGet(modelName, '/set/reportRank', data);
};

export const SystemAnalizeRankPost = (data) => {
  return NormalPost(modelName, '/set/reportRank', data);
};

// 使用者設定
export const SystemUserGetList = (data) => {
  return NormalGet(modelName, '/user', data);
};
export const SystemUserCreate = (data) => {
  return NormalPost(modelName, '/user', data);
};
export const SystemUserUpdate = (data) => {
  return NormalPut(modelName, '/user', data);
};
export const SystemUserDelete = (data) => {
  return NormalDelete(modelName, `/user?uuid=${data}`, data);
};
export const SystemUserPwUpdate = (data) => {
  return NormalPost(modelName, '/user/change/password', data);
};
// 使用者設定 同步
export const SystemUserSynchronizeGet = (data) => {
  return NormalGet(modelName, '/user/synchronize', data);
};
export const SystemUserSynchronizePost = (data) => {
  return NormalPost(modelName, '/user/synchronize', data);
};

export const SystemRoleGetList = (data) => {
  return NormalGet(modelName, '/role', data);
};
export const SystemRoleCreate = (data) => {
  return NormalPost(modelName, '/role', data);
};
export const SystemRoleUpdate = (data) => {
  return NormalPut(modelName, '/role', data);
};
export const SystemRoleDelete = (data) => {
  return NormalDelete(modelName, `/role?uuid=${data}`, data);
};

export const SystemRolePermissionGetList = (data) => {
  return NormalGet(modelName, '/rolePermission', data);
};
export const SystemRolePermissionCreate = (data) => {
  return NormalPost(modelName, '/rolePermission', data);
};
export const SystemRolePermissionUpdate = (data) => {
  return NormalPut(modelName, '/rolePermission', data);
};

export const SystemBuUserGetList = (data) => {
  return NormalGet(modelName, '/buUser', data);
};
export const SystemBuUserCreate = (data) => {
  return NormalPost(modelName, '/buUser', data);
};
export const SystemBuUserUpdate = (data) => {
  return NormalPut(modelName, '/buUser', data);
};
export const SystemBuUserDelete = (data) => {
  return NormalDelete(modelName, `/buUser?user_bu_id=${data}`);
};

export const SystemBuSearchDropDownGetList = (data) => {
  return NormalGet(modelName, '/buUser/dropdown', data);
}; // 廠區使用者設定篩選列
export const SystemBuUserDropDownGetList = (data) => {
  return NormalGet(modelName, '/settingInfo/dropdown', data);
};
// export const SystemRoleDropDownGetList = (data) => { return NormalGet(modelName, '/settingInfo/dropdown?type=1', data); };
// export const SystemBuDropDownGetList = (data) => { return NormalGet(modelName, '/settingInfo/dropdown?type=2', data); };
// export const SystemUserDropDownGetList = (data) => { return NormalGet(modelName, '/settingInfo/dropdown?type=3', data); };
// 初始資料匯入
export const SystemUploadGetInfo = (data) => {
  return NormalGet(modelName, '/import/info', data);
};
export const SystemUserExampleDownload = (data) => {
  return NormalPost(modelName, '/example/download/user', data);
}; // 範本下載
export const SystemUserBuExampleDownload = (data) => {
  return NormalPost(modelName, '/example/download/userBu', data);
}; // 範本下載
export const SystemUserUpload = (data) => {
  return request.post(`${modelName}/import/user`, data);
};
export const SystemUserBuUpload = (data) => {
  return request.post(`${modelName}/import/userBu`, data);
};
export const SystemImportError = (data) => {
  return NormalGet(modelName, '/import/error', data);
};

// 通知設定
export const SystemMailServerGetList = (data) => {
  return NormalGet(modelName, '/set/mailserver', data);
};
export const SystemMailServerUpdate = (data) => {
  return NormalPost(modelName, '/set/mailserver', data);
};
export const SystemMailServerTest = (data) => {
  return NormalPost(modelName, '/mail/sendTest', data);
};
export const SystemWeChatServerGet = (data) => {
  return NormalGet(modelName, '/set/weChatServer', data);
};
export const SystemWeChatServerUpdate = (data) => {
  return NormalPost(modelName, '/set/weChatServer', data);
};
export const SystemWeChatServerTest = (data) => {
  return NormalPost(modelName, '/wechat/sendTest', data);
};

// 管制上線人數
export const SystemLoginLockGetList = () => {
  return NormalGet(modelName, '/loginLock');
};
export const SystemLoginLockDelete = (userUid) => {
  return NormalDelete(modelName, `/loginLock?user_uid=${encodeURIComponent(userUid)}`);
};

export const SystemKickUserGetList = (data) => {
  return NormalGet(modelName, '/kickOut', data);
};
export const SystemLoginKickUserGetList = (loginData) => {
  return axios
    .create({
      baseURL: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: `Basic ${loginData}`,
        // Authorization: loginData,
      },
      withCredentials: true,
    })
    .get(`${modelName}/kickOut`);
};
export const SystemKickUserDelete = (data) => {
  return NormalDelete(modelName, `/kickOut?uuid=${data}`, data);
};
export const SystemLoginKickUserDelete = (loginData, data) => {
  return axios
    .create({
      baseURL: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: `Basic ${loginData}`,
        // Authorization: loginData,
      },
      withCredentials: true,
    })
    .delete(`${modelName}/kickOut?uuid=${data}`);
};

//
// License
//

/** 取得系統授權 */
export const SystemLicenseStatusGet = (data) => {
  return NormalGet(modelName, '/license', data);
};
export const SystemRegistryGet = (data) => {
  return NormalPost(modelName, '/license', data);
};
export const SystemLicenseSubmit = (data) => {
  return NormalPut(modelName, '/license', data);
};
export const SystemLicenseChangeInfoGet = (data) => {
  return NormalGet(modelName, '/licenseInfo', data);
};

// 季度線
export const SystemQuarterLineGetDropDown = (data) => {
  return NormalGet(modelName, '/scheduler/quarterLine/dropDown', data);
};
export const SystemQuarterLineGetList = (data) => {
  return NormalGet(modelName, '/scheduler/quarterLine', data);
};
export const SystemQuarterLineCreate = (data) => {
  return NormalPost(modelName, '/scheduler/quarterLine', data);
};
export const SystemQuarterLineUpdate = (data) => {
  return NormalPut(modelName, '/scheduler/quarterLine', data);
};
export const SystemQuarterLineDelete = (data) => {
  return NormalDelete(modelName, '/scheduler/quarterLine', data);
};
